module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00092.35743283.jpg";